import * as _ from 'lodash';

export interface ICommand {

}

export class ChangeTextureCommand implements ICommand {
  public value?: number;
  public texture?: string;
  public enable?: boolean;
}

export interface HideObjectsCommand extends ICommand {
  objects: string[];
  operator?: FilterOperators;
  trim?: boolean;
}

export interface ShowObjectsCommand extends ICommand {
  objects: string[];
  operator?: FilterOperators;
  trim?: boolean;
}

export interface ChangeEmitColorCommand extends ChangeTextureCommand {
  materials:string[];
  color?: string;
}

export interface DisableEmitColorCommand extends ICommand {
  materials: string[];

}

export interface ChangeOpacityCommand extends ChangeTextureCommand {
  materials: string[];

}
export interface ChangeCavityCommand extends ChangeTextureCommand {
  materials: string[];

}

export interface ChangeDiffuseCommand extends ChangeTextureCommand {
  materials: string[];

}

export interface ChangeRoughnessCommand extends ChangeTextureCommand {
  materials: string[];
}

export interface ChangeGlossinessCommand extends ChangeTextureCommand {
  materials: string[];
}

export interface ChangeAoPBRCommand extends ChangeTextureCommand {
  materials: string[];
}

export interface ChangeAlbedoPBRCommand extends ChangeTextureCommand {
  materials: string[];
  color?: string;
}

export interface ChangeBumpMapCommand extends ChangeTextureCommand {
  materials: string[];
}

export interface ChangeMetalnessCommand extends ChangeTextureCommand {
  materials: string[];
}

export interface ChangeUVScaleCommand extends ICommand
{
  materials: string[];
  channel: string;
  scaleX: number;
  scaleY: number;
}

export interface ChangeUVRotationCommand extends ICommand
{
  materials: string[];
  channel: string;
  rotation: number;
}

export interface ChangeUVOffsetCommand extends ICommand
{
  materials: string[];
  channel: string;
  offsetX: number;
  offsetY: number;
}

export enum FilterOperators {
    Equal = 'Equal',
    Contains = 'Contains',
    StarsWith = 'StartsWith',
    EndsWith = 'EndsWith',
    Regex = 'Regex',
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/services/sketchfab/commands.ts